import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { createContext as i, useState as e, useCallback as n } from "react";
import r from "@mui/joy/Stack";
import { Notification as s } from "./Notification.js";
const m = i({ push: () => ({ remove: () => {
} }) }), a = ({ children: i2 }) => {
  const [a2, d] = e([]), p = n((t2) => {
    d((o2) => o2.filter((o3) => o3.id !== t2));
  }, []), u = n(({ message: t2, title: o2, type: i3, options: e2, icon: n2, button: r2 }) => {
    const s2 = (e2 == null ? void 0 : e2.id) || Date.now();
    return d((m2) => [...m2, { id: s2, icon: n2, button: r2, message: t2, title: o2, type: i3, duration: e2 == null ? void 0 : e2.duration }]), { remove: () => p(s2) };
  }, [p]), c = a2.some((t2) => !!t2.button);
  return t(m.Provider, { value: { push: u }, children: [i2, o(r, { spacing: 1, sx: { position: "fixed", bottom: 12, right: 12, maxWidth: c ? "550px" : "400px", zIndex: 9999 }, children: a2.map((t2) => o(s, { id: t2.id, icon: t2.icon, button: t2.button, message: t2.message, notificationTitle: t2.title, type: t2.type, autoHideDuration: t2.duration, onClose: p }, t2.id)) })] });
};
export {
  m as NotificationContext,
  a as NotificationProvider
};
//# sourceMappingURL=NotificationProvider.js.map
